import React, { useEffect, useState } from "react";
import { Button, Modal,Timeline,Card } from "antd";
import DiffViewer from "react-diff-viewer";
import axios from "axios";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { API_BASE_URL, API_ENDPOINT_BLOG_STORAGE_URL, MANAGE_PREPIX_PATH } from "configs/AppConfig";
import Loader from "components/util-components/Loader";

const PageHistory = ({ id,hideLoading,showLoading,selectedTab,entityName,appInstanceId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
 const  [dataSource,setDataSource] = useState([]);
 const [compareData,setCompareData]=useState([]);
   const [userDetails, setUserDetails] = useState({});      
   var usersList = [];
 const [loading,setLoading]=useState(true);


  useEffect(()=>{
    async function fetchData(){
    // const templatePagesDraftValue= JSON.parse(templatePagesDraft);
    setLoading(true);
   await axios.get(`${API_ENDPOINT_BLOG_STORAGE_URL}/blob-storage/blob-audit-data?entityName=${entityName}&entityId=${id}`, {headers: {
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        'Content-Type': 'application/json',
        accountUserId: localStorage.getItem("accountUserId"),
        accountId: localStorage.getItem("accountId"),
        appInstanceId:appInstanceId
    }}).then(res => {
        if(res.status===200) {
            setLoading(false);
            // console.log(res.data);
            // setHistoryData(res?.data);
            const dataSource = Object.entries(res?.data).map(([timestamp, details], index) => ({
                key: index, // AntD table requires a unique key
                timestamp,
                pageName: details.pageName,
                description: details.description,
                comments: details.comments,
                userEdited: details.userEdited,
                userCreated:details.userCreated,
                createdDatetime:details.createdDatetime,
                updatedDatetime:details.updatedDatetime,
                content: details.content
              }));
        usersList = dataSource.map((item) => item?.userEdited);
        usersList.push(dataSource[0]?.userCreated)
        setDataSource(dataSource);
        }
    }).catch(error=>{
        setLoading(false);
      console.log(error);
    });
    const uniqueIds = Array.from(
      new Set(usersList.filter((id) => id !== undefined))
    );
    setLoading(true);
   await axios.post(`${API_BASE_URL}${MANAGE_PREPIX_PATH}/auth/users-list`,uniqueIds, {headers: {
      'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      'Content-Type': 'application/json',
      accountUserId: localStorage.getItem("accountUserId"),
      accountId: localStorage.getItem("accountId"),
      appInstanceId: "developerPortal"
  }}).then(res => {
      if(res.status===200) {
        setLoading(false);
        const userDetailsMap = {};
        res?.data.forEach((user) => {
          userDetailsMap[user.id] = user;
        });
        setUserDetails(userDetailsMap);
      }
    }).catch(error=>{
      setLoading(false);
    console.log(error);
  });
}
  fetchData()
  },[])


  const handleCompare = () => {
    if (selectedItems.length === 2) {
      setIsModalVisible(true);
    }
  };

  const convertToBrowserDateTime = (timestamp) => {
    // Convert timestamp to milliseconds (if needed)
    const date = new Date(Number(timestamp));
    return date.toLocaleString(); // Format based on the browser's locale
  };
  
  // State to track selected checkboxes
  const [selectedItems, setSelectedItems] = useState([]);

  // Handler for checkbox selection
  const handleCheckboxChange = (checked, edit) => {
    let data = {};
    data["createdDatetime"] = convertToBrowserDateTime(edit?.createdDatetime);
    data["updatedDatetime"] = convertToBrowserDateTime(edit?.updatedDatetime);
    data["userCreated"] = edit?.userCreated?`${userDetails[edit?.userCreated]?.firstName} ${userDetails[edit?.userCreated]?.lastName}`:"NA";
    data["userEdited"] = edit?.userEdited?`${userDetails[edit?.userEdited]?.firstName} ${userDetails[edit?.userEdited]?.lastName}`:"NA";
    data["content"] = edit?.content;
    data["pageName"] = edit?.pageName;
    data["description"] = edit?.description;
    data["previewImage"] = edit?.previewImage;
    data["dataForPreview"] = edit?.dataForPreview;
    data["revision"] = edit?.revision;
    data["stable"] = edit?.stable;
    data["comments"] = edit?.comments;
    data["id"] = edit?.id;
    if (checked) {
      // Prevent selecting more than 2 items
      if (selectedItems.length >= 2) {
        alert("You can only select up to 2 items.");
        return;
      }
      setCompareData((prev1) => [...prev1, data]);
      setSelectedItems((prev) => [...prev, edit]);
    } else {
      // Remove item from selected list
      setCompareData((prev) => prev.filter((item) => item.pageName !== data.pageName));
      setSelectedItems((prev) => prev.filter((item) => item.pageName !== edit.pageName));
      
    }
  };

  return (<>
    {loading? <Loader spinning={loading} cover="content" />:null}
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
      <div style={{ width: "100%"}}>
        <div
  style={{
    display: "flex",
    alignItems: "flex-end", // Align items to the bottom
    gap: "16px", // Space between items
    marginBottom: "20px", // Space below the row
  }}
>
 <div
    style={{
      display: "flex",
      flexDirection: "column", // Arrange <p> tags in columns
      gap: "8px", // Space between rows
    }}
  >  <p>
    <span style={{ fontWeight: "bold" }}>User Created: </span>
    <span>
      {dataSource[0]?.userCreated
        ? `${userDetails[dataSource[0]?.userCreated]?.firstName || userDetails[dataSource[dataSource?.length-1]?.userCreated]?.firstName} 
           ${userDetails[dataSource[0]?.userCreated]?.lastName || userDetails[dataSource[dataSource?.length-1]?.userCreated]?.lastName}`
        : "NA"}
    </span>
    </p>
    <p>
    <span style={{ fontWeight: "bold" }}>Created Date: </span>
    <span>{convertToBrowserDateTime(dataSource[0]?.createdDatetime) || "NA"}</span>
  </p>
 </div>
  {/* Compare Button */}
</div>

        {/* Timeline with Top Border */}
        <div
          style={{
            borderTop: "2px solid #1890ff", // Add top border
            padding: "16px 0", // Space for content inside timeline
            marginTop: "16px", // Gap from previous content
          }}
        >
              <div style={{ textAlign: "center",marginBottom:"15px" }}>
  <Button
    type="primary"
    onClick={handleCompare}
    disabled={selectedItems.length !== 2}
  >
    Compare
  </Button>
</div>
          <Timeline mode="alternate">
            {dataSource.map((edit, index) => (
              <Timeline.Item
                key={index}
                color={index % 2 === 0 ? "blue" : "green"}
                dot={
                  <div
                    style={{
                      background: index % 2 === 0 ? "#1890ff" : "#52c41a",
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                    }}
                  />
                }
              >
                  <div style={index % 2 !== 0 ? {display: "flex", alignItems: "center", gap: "8px",flexDirection:"row-reverse",justifyContent:"end" }: {display: "flex", alignItems: "center", gap: "8px" }}>
                   <input
                      type="checkbox"
                      id={`checkbox-${index}`}
                      checked={selectedItems.includes(edit)}
                      disabled={!selectedItems.includes(edit) && selectedItems.length===2}
                      onChange={(e) => handleCheckboxChange(e.target.checked, edit)}
                      style={index % 2 === 0 ? {marginLeft:"-27px"}:{marginRight:"-20px"}}
                    />
                <Card style={{ marginBottom: "8px" }}>
                  <p>
                    <strong>Edited at:</strong> {convertToBrowserDateTime(edit?.updatedDatetime)}
                  </p>
                  <p>
                    <strong>Edited by:</strong>
                    {edit?.userEdited
                      ? `${userDetails[edit?.userEdited]?.firstName || ""} ${userDetails[edit?.userEdited]?.lastName || ""}`
                      : "NA"}
                  </p>
                </Card>
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
        </div>
      </div>
    </div>
      {/* <SkeletonLoader  columns={columns}  loading={loading}/>
      <Table
        dataSource={dataSource}
        columns={columns}
        rowSelection={rowSelection}
        bordered
      /> */}

        <Modal
        title="Comparison"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="80%" // Adjust width as needed (e.g., 80% of the viewport)
        bodyStyle={{
            maxHeight: '70vh', // Limits max height
            overflowY: 'auto', // Adds scroll if content exceeds height
        }}
        >
        {/* <h3>Comparison Between Selected Records</h3> */}
        <DiffViewer
            oldValue={JSON.stringify(compareData[0], null, 2)} // Format JSON for readability
            newValue={JSON.stringify(compareData[1], null, 2)}
            splitView={true}
        />
        </Modal>

    </div>
    </>
  );
};

export default PageHistory;
